/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Konsultan_A2dInputs */

const en_mk_sol_konsultan_a2d = /** @type {(inputs: Mk_Sol_Konsultan_A2dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finds precedent inside the workspace and on the web when permitted, with a checkable source list.`)
};

const id_mk_sol_konsultan_a2d = /** @type {(inputs: Mk_Sol_Konsultan_A2dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mencari preseden di dalam workspace dan di web bila diizinkan, dengan daftar sumber yang bisa diperiksa.`)
};

/**
* | output |
* | --- |
* | "Finds precedent inside the workspace and on the web when permitted, with a checkable source list." |
*
* @param {Mk_Sol_Konsultan_A2dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_konsultan_a2d = /** @type {((inputs?: Mk_Sol_Konsultan_A2dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Konsultan_A2dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_konsultan_a2d(inputs)
	return en_mk_sol_konsultan_a2d(inputs)
});